import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckMONames } from '@api/hitoryCheck';

import { TComparisonVendorDTO } from '@interfaces/cmModule/dto/historyCheckDTO';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_SITE_MO_NAMES } from '@constants/queryKeys';

interface IUseQueryHistoryCheckMoNamesReturnValue {
	moNames: string[];
	isLoadingMoNames: boolean;
}

const useQueryHistoryCheckMoNames = ({
	comparisonId,
	isMavenirVendor,
}: TComparisonVendorDTO): IUseQueryHistoryCheckMoNamesReturnValue => {
	const {
		data: moNames,
		isLoading,
		isFetching,
	} = useQuery<string[]>({
		queryKey: [CONSISTENCY_SITE_MO_NAMES, comparisonId],
		queryFn: () => getHistoryCheckMONames(comparisonId),
		enabled: [comparisonId, isMavenirVendor],
		...refetchOptions,
	});

	return {
		moNames: moNames || [],
		isLoadingMoNames: (isLoading && !!moNames)
			|| isFetching,
	};
};

export default useQueryHistoryCheckMoNames;
